module.exports = __webpack_public_path__ + "static/media/tree.284528b8.png";